import * as _ from 'lodash'
import { HttpRequest } from '../../../util/http'
import { generateUUID } from '../../../util/uuid';
import {
  IClientsIndexResponse, IFileProfileResponse, IFileSurvey
  , IFinalizeSample, ISurveySampleInstance, IVerificationBeforeSend
  , ISurveyCoachingVarRule
} from './interfaces'
import { AnyARecord } from 'dns';

class SurveyManagementHttpClass {
  getClients(): Promise<IClientsIndexResponse> {
    const endpoint = '/scripts/sampling/clientview'
    const method = 'POST'

    return HttpRequest.fetch<IClientsIndexResponse>(endpoint, { method })
  }

  getCoachingFormRuleVars() {
    const endpoint = '/scripts/sampling/coaching_getvars'
    const method = 'GET'
    const data = {}

    return HttpRequest.fetch<any>(endpoint, { method })
  }

  addRule(name, rule, result, sort) {
    const endpoint = '/scripts/sampling/coaching_addrule'
    const method = 'POST'
    const data = { var: name, rule: rule, result: result, sort: sort }

    return HttpRequest.fetch<any>(endpoint, { method, data })
  }

  addCoachingFormRuleVar(v) {
    const endpoint = '/scripts/sampling/coaching_addvar'
    const method = 'POST'
    const data = { var: v }

    return HttpRequest.fetch<any>(endpoint, { method, data })
  }

  remCoachingFormRuleVar(v) {
    const endpoint = '/scripts/sampling/coaching_remvar'
    const method = 'POST'
    const data = { var: v }

    return HttpRequest.fetch<any>(endpoint, { method, data })
  }

  remCoachingFormRule(id, v) {
    const endpoint = '/scripts/sampling/coaching_remrule'
    const method = 'POST'
    const data = { id: id, var: v }

    return HttpRequest.fetch<any>(endpoint, { method, data })
  }

  getCoachingFormRules(v): Promise<any[]> {
    const endpoint = '/scripts/sampling/coaching_getrules'
    const method = 'POST'
    const data = { var: v }

    console.log(v)
    return HttpRequest.fetch<ISurveyCoachingVarRule[]>(endpoint, { method, data }).then(rs => { console.log(rs); return rs })
  }


  getFieldFormRuleVars() {
    const endpoint = '/scripts/sampling/field_getvars'
    const method = 'GET'
    const data = {}

    return HttpRequest.fetch<any>(endpoint, { method })
  }

  addFieldRule(name, rule, result, sort) {
    const endpoint = '/scripts/sampling/field_addrule'
    const method = 'POST'
    const data = { var: name, rule: rule, result: result, sort: sort }

    return HttpRequest.fetch<any>(endpoint, { method, data })
  }

  addFieldFormRuleVar(v) {
    const endpoint = '/scripts/sampling/field_addvar'
    const method = 'POST'
    const data = { var: v }

    return HttpRequest.fetch<any>(endpoint, { method, data })
  }

  remFieldFormRuleVar(v) {
    const endpoint = '/scripts/sampling/field_remvar'
    const method = 'POST'
    const data = { var: v }

    return HttpRequest.fetch<any>(endpoint, { method, data })
  }

  remFieldFormRule(id, v) {
    const endpoint = '/scripts/sampling/field_remrule'
    const method = 'POST'
    const data = { id: id, var: v }

    return HttpRequest.fetch<any>(endpoint, { method, data })
  }

  getFieldFormRules(v): Promise<any[]> {
    const endpoint = '/scripts/sampling/field_getrules'
    const method = 'POST'
    const data = { var: v }

    console.log(v)
    return HttpRequest.fetch<ISurveyCoachingVarRule[]>(endpoint, { method, data }).then(rs => { console.log(rs); return rs })
  }

  endMonth(clientAbbr: string) {
    const endpoint = '/scripts/sampling/endmonth'
    const method = 'POST'
    const data = { client: clientAbbr }

    return HttpRequest.fetch<any>(endpoint, { method, data })
  }

  getFileProfile(clientAbbr: string): Promise<IFileProfileResponse> {
    const endpoint = '/scripts/sampling/processclient'
    const method = 'POST'
    const data = { client: clientAbbr }

    return HttpRequest.fetch<IFileProfileResponse>(endpoint, { method, data }).then((res) => {
      if (res.response) {
        res.response.map((survey) => {
          survey.id = generateUUID()

          if (survey.JAC instanceof Array) {
            survey.JAC.forEach((instance) => instance.surveyType = 'JAC')
          }

          if (survey.online instanceof Array) {
            survey.online.forEach((instance) => instance.surveyType = 'online')
          }

          if (survey.totals instanceof Array) {
            survey.totals.forEach((instance) => instance.surveyType = 'totals')
          }

          return survey
        })
      }

      return res;
    })
  }

  getPrioritizedFileProfile(clientAbbr: string, priority_: string): Promise<IFileProfileResponse> {
    const endpoint = '/scripts/sampling/processclient'
    const method = 'POST'
    const data = { client: clientAbbr, priority: priority_ }

    return HttpRequest.fetch<IFileProfileResponse>(endpoint, { method, data }).then((res) => {
      if (res.response) {
        res.response.map((survey) => {
          survey.id = generateUUID()

          if (survey.JAC instanceof Array) {
            survey.JAC.forEach((instance) => instance.surveyType = 'JAC')
          }

          if (survey.online instanceof Array) {
            survey.online.forEach((instance) => instance.surveyType = 'online')
          }

          if (survey.totals instanceof Array) {
            survey.totals.forEach((instance) => instance.surveyType = 'totals')
          }

          return survey
        })
      }

      return res;
    })
  }

  beforeVerification(clientAbbr: string, fileSurveys: IFileSurvey[]) {
    const method = 'POST'
    // tslint:disable-next-line:variable-name
    const ver_request: IVerificationBeforeSend = {
      clientId: clientAbbr,
      JACSurveySamples: [],
      OnlineSamples: [],
    };

    fileSurveys.forEach((fileSurvey) => {
      const { surveyName } = fileSurvey

      if (fileSurvey.JAC instanceof Array) {
        fileSurvey.JAC.forEach((instance) => {
          const { sampleToday: quantity, branchName, category } = instance
          const sampleInstance: ISurveySampleInstance = { surveyName, quantity, branchName, category };

          ver_request.JACSurveySamples.push(sampleInstance);
        })
      } else {
        const { sampleToday: quantity, category } = fileSurvey.JAC
        const sampleInstance: ISurveySampleInstance = { surveyName, quantity, category };

        ver_request.JACSurveySamples.push(sampleInstance);
      }

      if (fileSurvey.online instanceof Array) {
        fileSurvey.online.forEach((instance) => {
          const { sampleToday: quantity, branchName, category } = instance
          const sampleInstance: ISurveySampleInstance = { surveyName, quantity, branchName, category };

          ver_request.OnlineSamples.push(sampleInstance);
        })
      } else {
        const { sampleToday: quantity, category } = fileSurvey.online
        const sampleInstance: ISurveySampleInstance = { surveyName, quantity, category };

        ver_request.OnlineSamples.push(sampleInstance);
      }
    })

    //return Promise.resolve(ver_request)

    const data = { ver_request }
    return HttpRequest.fetch<IVerificationBeforeSend>('/scripts/sampling/verifysample', { method, data })
  }

  finalizeOnlineSample(batchId: string, action: 'confirm' | 'cancel') {
    const method = 'POST'
    const onlineEndpoint = '/scripts/sampling/finalizeonlinesample'
    const data = { batchId, action }

    return HttpRequest.fetch<IFinalizeSample>(onlineEndpoint, { method, data })
  }

  finalizePhoneSample(batchId: string, action: 'confirm' | 'cancel') {
    const method = 'POST'
    const phoneEndpoint = '/scripts/sampling/finalizephonesample'
    const data = { batchId, action }

    return HttpRequest.fetch<IFinalizeSample>(phoneEndpoint, { method, data })
  }

  downloadInterviews(batchId: string) {
    window.open(`/scripts/sampling/downloadInterviews?batchId=${batchId}`)
  }

  downloadInterviewsByCategory(batchId: string, category: string, surveyName: string) {
    window.open(`/scripts/sampling/downloadInterviewsByCategory?batchId=${batchId}&category=${category}&survey_name=${surveyName}`);
  }

  refreshQuotas(clientAbbr: string) {
    const method = 'POST'
    const endpoint = '/scripts/sampling/updatequotas'
    const data = { client: clientAbbr }

    return HttpRequest.fetch<void>(endpoint, { method, data })
  }
}

export const SurveyManagementHttp = new SurveyManagementHttpClass()
